<template>
    <div class="container" style="width: 100vw; height: 100vh;">
    <div class="card" style="padding: 30px;height: 90vh;overflow-y: scroll;margin-top: -30px;">
    <div class="card-body" style="margin-top: -40px;">
    <span class="text-danger fs-3 fw-bold">LTC Red Army</span>
    <br>
    <span class="text-danger fs-4 fw-bold">User</span>
    <!-- <span class="text-black-50 fs-3 fw-bold"> Duties 2023</span> -->
    
   
    <br>
        <div class="row">
                  <div class="col-xs-12 col-sm-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border: 1px solid black;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold ">Customer type</span>
                    </label>
                  </div>
                  <div class="col-xs-12 col-sm-8 " style="height: 35px;">
                    <button style="height: 35px;width:100%" class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                      {{ selectedCustType==0?"Please select": customerTypeNames['type'+selectedCustType]}}
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                      <li @click="getQuestionsAndChoices(1);">&nbsp;Normal Customer&nbsp;</li>
                      <li @click="getQuestionsAndChoices(2);">&nbsp;Dealer & Shop Customer&nbsp;</li>
                      <li @click="getQuestionsAndChoices(3);">&nbsp;FTTH Customer&nbsp;</li>
                    </ul>
                  </div>
        </div>
        <hr>
        <div v-if="selectedCustType!=0" style="height: 40vh;overflow-y: scroll;">
          <!-- <div v-if="selectedCustType==1"> -->
            <div v-for="(questionData, index) in this['questionCType'+selectedCustType]" v-bind:key="index">
            <div class="row">
              <div v-if="index==0||questionCType1[index-1].q_id!=questionData.q_id" class="col-xs-12 offset-sm-2 col-sm-10 text-start">
                <div v-if="index!=0"><hr></div>
                {{ (index+1)+'.'+questionData.question_msg_la }}
              </div>
            </div>
            <div class="row" v-for="(choice, index) in questionData.choices" v-bind:key="index">
              <div class="col-xs-12 offset-sm-2 col-sm-10">
                <!-- {{ choice.isSelected }} -->
                <div class="form-check form-switch text-start">
                  <input class="form-check-input" type="checkbox" v-model="choice.selected" @click="clickChoice(choice,questionData.choices);">
                  <label class="form-check-label" for="flexSwitchCheckDefault">{{ choice.choice_msg_la + (choice.is_single_choice?'(Only this Choice)':'')}}</label>
                </div>
              </div>
            </div>  
            </div>
          <!-- </div> -->
        </div>
        <div v-if="selectedCustType!=0">
        <div class="row">
                  <div class="col-xs-12 col-sm-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border: 1px solid black;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold ">Customer name</span>
                    </label>
                  </div>
                  <div class="col-xs-12 col-sm-8" style="height: 35px;overflow-y: hidden;">
                    <input type="text" class="form-control" style="width: 100%;height: 35px;" v-model="custName">
                  </div>
        </div>
        <div class="row">
                  <div class="col-xs-12 col-sm-4 " style="background-color: #EAEDED;height: 35px;padding-top: 5px;border: 1px solid black;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold ">Phone Number1</span>
                    </label>
                  </div>
                  <div class="col-xs-12 col-sm-8" style="height: 35px;overflow-y: hidden;">
                    <input type="number" class="form-control" style="width: 100%;height: 35px;" v-model="phoneNumber">
                  </div>
        </div>   
        <div class="row">
                  <div class="col-xs-12 col-sm-4 " style="background-color: #EAEDED;height: 50px;border: 1px solid black;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold ">Village<br>
                      (Optional)</span>
                    </label>
                  </div>
                  <div class="col-xs-12 col-sm-8" style="height: 50px;overflow-y: hidden;">
                    <textarea class="form-control" style="width: 100%;height: 50px;" aria-label="With textarea" v-model="remarkAddress"></textarea>
                  </div>
        </div>    
        </div> 
    </div>
    </div>
        <div class="row">
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-danger" @click="$router.push('/home');" style="width:50%;" >
              <i class="fas fa-house"></i> Home
            </button>
            <button v-if="selectedCustType!=0" type="submit" class="btn btn-success" style="width:50%;" @click="clickSave();">
              <i class="fas fa-floppy-disk"></i> Send
            </button>
            </div>
            <!-- <div class="col-6 text-center">
            <button v-if="selectedCustType!=0" type="submit" class="btn btn-success" style="width:100%;" @click="clickSave();">
              <i class="fas fa-floppy-disk"></i> Send
            </button>
            </div> -->
        </div>
    </div>
    
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import axios from 'axios';
import Global from './GlobalVariable';
import Service from './Service';

export default {
  name: 'UserPage',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
      lat:0.00,
      lng:0.00,
      customerTypeNames:{type1:"Normal Customer",type2:"Dealer & Shop Customer",type3:"FTTH Customer"},
      questionCType1:[],
      questionCType2:[],
      questionCType3:[],
      selectedCustType:0,
      startDate:null,
      remarkAddress:"",
      custName:"",
      phoneNumber:""

    };
  },
  mounted() {
    var vm = this;
    vm.getLocation();
    // vm.getQuestionsAndChoices();
  },
  methods: {
   verifyOtp: function(){
    this.$router.push("/home");
   },
  getLocation: function() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
  } else {
    alert("Geolocation is not supported by this browser.");
  }
  },
  showPosition: function(position) {
    this.lat = position.coords.latitude;
    this.lng = position.coords.longitude;
  },
  showError:function(error) {
    switch(error.code) {
      case error.PERMISSION_DENIED:
        alert("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        alert("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        alert("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        alert("An unknown error occurred.");
        break;
    }
  },
  clickSaveMockup:function(){
    var vm = this;
    if(vm.validateForm()){

      vm.$swal.fire({
        title: 'Do you want to send data?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Send',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          vm.$swal.fire('Completed!', '', 'success')
          vm.selectedCustType = 0;
        } else if (result.isDenied) {
          // this.$swal.fire('Changes are not saved', '', 'info')
        }
      });
          
    }else{
      vm.$swal.fire({
        icon: 'error',
        title: 'Warning!',
        text: 'Please select customer type and do survey!',
        // footer: '<a href="">Why do I have this issue?</a>'
      })
            
    }
      
    },
  validateForm:function(){
    var flag = true;
    if(this.selectedCustType==0){
        flag = false;
    }
    return flag
  },
  getQuestionsAndChoices: async function(custType){
    var vm = this;
    var d = new Date();
    vm.startDate = d.getTime();
    vm.selectedCustType = custType;
    if(vm['questionCType'+custType].length==0){
    vm.showLoading();
      return await axios.post(Global.backendPath+"question/getQuestionsAndChoices", {"userId":14749,"custType":custType},
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      // Global.userIdentify = 14749
      //Global.userName = VT4584
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          vm['questionCType'+custType]=response.data.result;
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
      });
    }
   },
  clickChoice:function(currentChoice,allChoice){
    if(currentChoice.is_single_choice){
      //set uncheck for other is not single
      allChoice.forEach(function(item){
        if(currentChoice.q_id!=item.q_ud&&currentChoice.c_id!=item.c_id){
          item.selected=false;
        }
      });
    }else{
      //set uncheck single 
      allChoice.forEach(function(item){
        if(item.is_single_choice&&currentChoice.q_id!=item.q_ud&&currentChoice.c_id!=item.c_id){
          item.selected=false;
        }
      });
    }
  },
  clickSave:function(){
    var vm = this;
    vm.$swal.fire({
        title: 'Do you want to send data?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Send',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          vm.save();
        } 
      });
  },
  save:function(){
    var vm = this;
    vm.showLoading();
    var d = new Date();
    var jsonRequest = 
    {
      "survey":{
                startDate: vm.startDate,
                endDate: d.getTime(),
                remarkAddress:vm.remarkAddress, 
                custName:vm.custName,
                phoneNumber:vm.phoneNumber,
                userId:localStorage.getItem("userId")
              },
      "surveyAnswer":vm["questionCType"+vm.selectedCustType]
    };
    axios.post(Global.backendPath+"question/saveSurvey", jsonRequest,
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"){
          vm.$swal.fire('Completed!', '', 'success')
          vm.resetPage();
        //   vm['questionCType'+custType]=response.data.result;
        }else{
          vm.$swal.fire({
            icon: 'error',
            title: 'Warning!',
            text: 'Error!',
            // footer: '<a href="">Why do I have this issue?</a>'
          })
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
      });
    

  },
  resetPage:function(){
    var vm = this;
    vm.questionCType1=[];
    vm.questionCType2=[];
    vm.questionCType3=[];
    vm.selectedCustType=0;
    vm.startDate=null;
    vm.remarkAddress="";
    vm.custName="";
    vm.phoneNumber="";
  }
}
}

</script>

<style scoped>
.otp-keypad {
  max-width: 50%;
  margin: 0 auto;
}

.otp-keypad-button {
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  line-height: 60px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  background-color: #f1f1f1;
  border: none;
  outline: none;
  color: #333;
}

.otp-keypad-empty-space {
  height: 60px;
  width: 60px;
  background-color: transparent;
}

.nav-link.active {
  background-color: gray;
}
</style>
